import { Component } from '@angular/core';
import { ProfileService } from '../../services/profile/profile.service';
import { User } from '../../models/user/user-model';
@Component({
    selector: 'app-profile-view',
    templateUrl: './profile-view.component.html',
    styleUrls: ['./profile-view.component.css']
})
/** profile-view component*/
export class ProfileViewComponent {
    /** profile-view ctor */

  public user: User = new User();
  imagePath = "http://ssl.gstatic.com/accounts/ui/avatar_2x.png";
  constructor(private readonly profileService : ProfileService) {
    this.GetProfile();
  }

  GetProfile() {
    
    this.profileService.getProfile().subscribe(
      data => {
        this.user = data;
        if (this.user && this.user.imagePath != "" && this.user.imagePath != null) {
          this.imagePath = this.user.imagePath;
        }
        else {
          this.imagePath = "http://ssl.gstatic.com/accounts/ui/avatar_2x.png";
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/profile-components/profile-view/profile-view.component.ts